import PigletTransportApi from '@/api/piglet/pigletTransportApi';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async addOrUdpdate({dispatch}, form) {
      try {
        const response = await PigletTransportApi.addOrUpdate(form);
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async fetchAll({dispatch}) {
      try {
        const response = await PigletTransportApi.fetchAll();
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async remove({dispatch}, {id}) {
      try {
        const response = await PigletTransportApi.remove(id);
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    }
  }
}
